import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import { SomethingWrongIcon } from '../assets';
import { Wrapper, Header, Container, Img, Title, Description, Supporter } from './index.view';

const ErrorSomethingWrong = () => {
  const { t } = useTranslation();
  const contactEmail = () => <Supporter href="mailto:support@fanz.io">support@fanz.io.</Supporter>;
  return (
    <Wrapper>
      <Header>
        <Icon name="logo" />
      </Header>
      <Container maxWidth="md">
        <Img src={SomethingWrongIcon} alt="LinkHasExpired" />

        <Title>{t('paidSomethingWrongTitle')}</Title>

        <Description>
          {t('paidSomethingWrongDesc')}
          {contactEmail()}
        </Description>
      </Container>
    </Wrapper>
  );
};

export default ErrorSomethingWrong;
